import { Suspense } from 'react';
import { ErrorBoundary, type FallbackProps } from 'react-error-boundary';

function ErrorFallback({ error, resetErrorBoundary }: FallbackProps) {
  return (
    <div className='flex h-full flex-col items-center justify-center gap-4'>
      <p className='text-basic-black text-sm'>페이지를 불러오는 중 오류가 발생했습니다.</p>
      <p className='text-xs text-gray-400'>{(error as Error)?.message}</p>
      <button onClick={resetErrorBoundary} className='rounded-md bg-blue-500 px-4 py-2 text-sm text-white hover:bg-blue-600'>
        다시 시도
      </button>
    </div>
  );
}

export default function PageWrapper({ children }: { children: React.ReactNode }) {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback} onError={(error, info) => console.error(error, info.componentStack)}>
      <Suspense fallback={null}>{children}</Suspense>
    </ErrorBoundary>
  );
}
